import { Control, FieldErrors } from "react-hook-form";
import { RegionChipSelect } from "@/components/RegionChipSelect/RegionChipSelect";
import { UserV2FormValues } from "./UserFormV2";
import { MarketsAutocomplete } from "@/components/MarketsAutocomplete";
import { TagsHierarchyV2 } from "@/types/tagsV2";

interface PlatformFormPartProps {
  control: Control<UserV2FormValues>;
  errors: FieldErrors<UserV2FormValues>;
  regionOptions: { label: string; value: number }[];
  handleRegionsChange: (selectedRegions: number[]) => void;
  currentTags: number[];
  markets: TagsHierarchyV2[] | undefined;
  handleAgileMarketsChange: (selectedMarketTags: number[]) => void;
  currentAgileMarketTags: number[];
  disabled: boolean;
  loading: boolean;
  index: number;
}

export const PlatformFormPart = ({
  regionOptions,
  handleRegionsChange,
  currentTags,
  markets,
  handleAgileMarketsChange,
  currentAgileMarketTags,
  errors,
  disabled,
  loading,
  index,
}: PlatformFormPartProps) => (
  // TODO: use multi select autocomplete
  <>
    <RegionChipSelect
      regions={regionOptions}
      onChange={handleRegionsChange}
      value={currentTags}
      error={!!errors.roles?.[index]?.regionTags}
      helperText={errors.roles?.[index]?.regionTags?.message}
    />
    <MarketsAutocomplete
      data={markets}
      handleMarketsChange={handleAgileMarketsChange}
      currentMarketTags={currentAgileMarketTags}
      error={!!errors.roles?.[index]?.marketTags}
      helperText={errors.roles?.[index]?.marketTags?.message}
      disabled={disabled}
      loading={loading}
    />
  </>
);
